/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkCreatePersonasResponse
 */
export interface BulkCreatePersonasResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCreatePersonasResponse
     */
    userIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BulkCreatePersonasResponse
     */
    count: number;
}

/**
 * Check if a given object implements the BulkCreatePersonasResponse interface.
 */
export function instanceOfBulkCreatePersonasResponse(value: object): value is BulkCreatePersonasResponse {
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function BulkCreatePersonasResponseFromJSON(json: any): BulkCreatePersonasResponse {
    return BulkCreatePersonasResponseFromJSONTyped(json, false);
}

export function BulkCreatePersonasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreatePersonasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['user_ids'],
        'count': json['count'],
    };
}

export function BulkCreatePersonasResponseToJSON(json: any): BulkCreatePersonasResponse {
    return BulkCreatePersonasResponseToJSONTyped(json, false);
}

export function BulkCreatePersonasResponseToJSONTyped(value?: BulkCreatePersonasResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_ids': value['userIds'],
        'count': value['count'],
    };
}

